import { supabaseClient } from "@/lib/supabase";
import { useAuth } from "@/utils/auth";
import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "@tanstack/react-router";
import { toast } from "@patient-watch/ui/sonner";
import { useToastCopy } from "@/features/i18n/toastCopy";
import { useOwnOptionsStore } from "@/features/dictionaries/useOwnOptionsStore";

const deleteUser = async () => {
    const { data, error } = await supabaseClient.functions.invoke("public-delete-user");
    if (error) throw error;
    return data;
};
export const useDeleteUser = () => {
    const toastCopy = useToastCopy();
    const navigate = useNavigate();
    const auth = useAuth();
    return useMutation({
        mutationFn: () => deleteUser(),
        onSuccess: () => {
            toast.info(toastCopy.userDeleted);
            auth.logout();
            useOwnOptionsStore.getState().clear();
            navigate({ to: "/", search: {}, params: {} });
            window.location.reload();
            window.location.reload();
        },
        onError: (error) => {
            toast.error(error.message);
        },
    });
};
